// extracted by mini-css-extract-plugin
export default {"menuNavigation":"MenuList_menuNavigation__M4gPW","listItem":"MenuList_listItem__naRQo","active":"MenuList_active__TlnCO"};